import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, Typography, TextField, Button } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from '../axios';
import './Login.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ff9800', // Orange color
        },
    },
    typography: {
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    }
});

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const authToken = localStorage.getItem('token');
        if (authToken) {
            navigate('/dashboard');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/auth/login', {
                username,
                password,
            });
            if (response.data.status === 'success') {
                localStorage.setItem('first_name', response.data.first_name);
                localStorage.setItem('last_name', response.data.last_name);
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('permissions', JSON.stringify(response.data.permissions));

                const permissions = response.data.permissions;
                if (permissions.includes('dashboard') || permissions.includes('all')) {
                    navigate('/dashboard');
                } else {
                    navigate('/notifications');
                }
            } else {
                setError(response.data.message);
            }
        } catch (error) {
            setError('An error occurred. Please try again.');
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <div className="login-page">
                <CssBaseline />
                <div className="login-container">
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <img
                            src="img/logo-hlotus.png.webp"
                            alt="logo"
                            className="login-logo"
                        />
                        <Typography component="h1" variant="h4" className="login-title">
                            Hocus&Lotus App
                        </Typography>
                        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Username"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                variant="outlined"
                            />
                            {error && (
                                <Typography color="error" variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                                    {error}
                                </Typography>
                            )}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 4, mb: 1 }}
                            >
                                Login
                            </Button>
                        </Box>
                    </Box>
                </div>
            </div>
        </ThemeProvider>
    );
};

export default Login;
